const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PreCheck = async (registrationAccessKey, g_recaptcha_response, campaignId = null, mailId = null) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/v2/family/pre-check`, {
      method: "POST",
      body: JSON.stringify({ "rak": registrationAccessKey, "g_recaptcha_response": g_recaptcha_response, "campaign_id": campaignId, "mail_id": mailId }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`Erreur de pré-vérification!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const Check = async (registrationAccessKey, g_recaptcha_response, checkType, checkValue, campaignId = null, mailId = null) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/v2/family/check`, {
      method: "POST",
      body: JSON.stringify({ "rak": registrationAccessKey, "g_recaptcha_response": g_recaptcha_response, "check_type": checkType, "check_value": checkValue, "campaign_id": campaignId, "mail_id": mailId }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`Erreur de vérification!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const GetFamilyRegistration = async (accessToken) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/v2/family/registration`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    if (!response.ok) {
      throw new Error(`Erreur de chargement des inscriptions!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const NewRegistration = async (accessToken, student) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/v2/family/registration/new`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify(student),
    });
    if (!response.ok) {
      let error = await response.json();
      throw new Error(error?.error || "Erreur de création de la candidature!");
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateRegistration = async (accessToken, student) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/v2/family/registration/update/${student?.id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify(student),
    });
    if (!response.ok) {
      throw new Error(`Erreur de mise à jour de la candidature!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const ConfirmRegistration = async (accessToken, studentId) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/v2/family/registration/confirm/${studentId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    if (!response.ok) {
      throw new Error(`Erreur de confirmation de la candidature!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UnregisterRegistration = async (accessToken, studentId, reason) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/v2/family/registration/unregister/${studentId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify({ "unregistration_reason": reason }),
    });
    if (!response.ok) {
      throw new Error(`Erreur de désinscription de la candidature!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateContacts = async (accessToken, contacts) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/v2/family/registration/update-contacts`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify(contacts),
    });
    if (!response.ok) {
      throw new Error(`Erreur de mise à jour des contacts!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const DeleteRegistration = async (accessToken, registrationId) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/v2/family/registration/delete/${registrationId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    if (!response.ok) {
      throw new Error(`Erreur de suppression du dossier!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const CreateSlotChangeRequest = async (accessToken, payload) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/v2/family/registration/slot-change-requests`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errorBody = await response.json().catch(() => ({}));
      throw new Error(errorBody?.error || "Erreur de création de la demande de changement de créneau!");
    }
    const actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const DeleteSlotChangeRequest = async (accessToken, requestId) => {

  try {
    const response = await fetch(`${BACKEND_URL}/api/v2/family/registration/slot-change-requests/${requestId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    if (!response.ok) {
      const errorBody = await response.json().catch(() => ({}));
      throw new Error(errorBody?.error || "Erreur de suppression de la demande de changement de créneau!");
    }
    const actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const ApproveObservation = async (accessToken, observationId, responseMessage = "") => {
  const response = await fetch(`${BACKEND_URL}/api/v2/family/registration/observations/${observationId}/approve`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
    body: JSON.stringify({ response: responseMessage || "" }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result?.error || "Erreur lors de la confirmation de lecture de l'observation!");
  }
  return result;
};

const UpdateStudentPhoto = async (accessToken, studentId, newPhoto) => {
  try {
    const formData = new FormData();
    formData.append("file", newPhoto);

    const response = await fetch(`${BACKEND_URL}/api/v2/family/registration/update-avatar/${studentId}`, {
      method: "POST",
      credentials: "include",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });

    if (!response.ok) {
      const errorBody = await response.json().catch(() => ({}));
      throw new Error(errorBody?.error || "Erreur de mise a jour de la photo de l'eleve!");
    }

    const actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const InitHelloAssoPayment = async (accessToken, payload) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/v2/family/registration/init-helloasso-payment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorBody = await response.json().catch(() => ({}));
      throw new Error(errorBody?.error || "Erreur d'initialisation du paiement HelloAsso!");
    }

    const actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const RequestAccess = async (email, g_recaptcha_response) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/v2/family/request-access`, {
      method: "POST",
      body: JSON.stringify({ "email": email, "g_recaptcha_response": g_recaptcha_response }),
    });
    if (!response.ok) {
      throw new Error(`Erreur de demande d'accès personnel!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};


const familyAPI = {
  RequestAccess,
  PreCheck,
  Check,
  GetFamilyRegistration,
  NewRegistration,
  UpdateRegistration,
  ConfirmRegistration,
  UnregisterRegistration,
  UpdateContacts,
  DeleteRegistration,
  CreateSlotChangeRequest,
  DeleteSlotChangeRequest,
  ApproveObservation,
  UpdateStudentPhoto,
  InitHelloAssoPayment,
};

export default familyAPI;